import * as utils from './utils/index.js';
import { initMenu } from './menu.js';
import './modules/index.js';

/**
 * Punto de entrada de JS del tema (único bundle: dist/js/main.js).
 * - Módulos en modules/{slug}/js importados desde ./modules/index.js
 * - Menú, utilidades globales y comportamiento del layout
 */
function init() {
  // Inicializa menú principal (hamburguesa, overlay y submenús).
  initMenu();

  // Botón "volver al inicio" (simple, el estilo lo manejas tú).
  const toTop = document.querySelector('.back-to-top');
  if (toTop) {
    utils.on(toTop, 'click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}

document.addEventListener('DOMContentLoaded', init);

export default { init };


